import { Container, VStack } from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import HomeSearchSection from './HomeSearchSection';
import StateMarketList from './StateMarketList';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Home | CHS | Resource Matrix — Denim Health</title>
      </Helmet>
      <Container maxW="container.xl" px={{ base: 4, md: 8, lg: 10 }} py={{ base: 8, md: 10 }}>
        <VStack align="stretch" spacing={10}>
          <HomeSearchSection />
          <StateMarketList />
        </VStack>
      </Container>
    </>
  );
};

export default Home;
